<icc-list [items]="accessories" (select)="showInfo($event)" [itemTemplate]="'itemColor'"></icc-list>


